export default "__VITE_ASSET__D1EK1pcX__"